import request from '@/utils/request'


export function myxiangqing(data) {//获取个人详细信息
 return request({
    url:"/member/user/userInfo",
    method: 'post',
	data:data
  })
}
export function Notification(data) {//系统消息
  return request({
    url: `/user/message?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=1`,
	method: 'get'
  })
}
export function myInvitation(data) {//我发布的帖子
  return request({
    url:`/invitation/myInvitation?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyWord=${data.keyWord}`,
    method: 'get'
  })
}
export function myPicks(data) {//我收藏的帖子
 return request({
    url:`/invitation/pick/page?pageNum=${data.pageNum}&size=${data.size}`,
    method: 'get'
  })
}
export function mypoints(data) {//我的积分记录
 return request({
    url:"/point/myPoint",
    method: 'post',
	data:data
  })
}
export function mywebinar(data) {//我的培训数据
 return request({
    url:`/seminarRegister/mySeminarRegister?pageNum=${data.pageNum}&pageSize=${data.pageSize}&type=${data.type}`,
    method: 'get'
  })
}
export function pointjilu(data) {
  return request({
    url: `/point/myPoint`,
    method: 'post',
	data:data
  })
}

